var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_43",
    "data-name": "Komponente 10 \\u2013 43",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7-days",
    "data-name": "7-days",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35410",
    "data-name": "Gruppe 35410",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46718",
    "data-name": "Pfad 46718",
    d: "M53.536,33.243V9.75A4.755,4.755,0,0,0,48.786,5H44.614V4a4,4,0,0,0-8,0V5H16.922V4a4,4,0,0,0-8,0V5H4.75A4.755,4.755,0,0,0,0,9.75V52.5a4.755,4.755,0,0,0,4.75,4.75h6.674a1.25,1.25,0,0,0,0-2.5H4.75A2.253,2.253,0,0,1,2.5,52.5V20.893H51.036V32.564a15.848,15.848,0,0,0-17.3,22.186H22.674a1.25,1.25,0,0,0,0,2.5H35.18A15.847,15.847,0,1,0,53.536,33.243ZM39.114,4a1.5,1.5,0,0,1,3,0V8.5a1.5,1.5,0,0,1-3,0ZM11.422,4a1.5,1.5,0,1,1,3,0V8.5a1.5,1.5,0,0,1-3,0ZM2.5,18.393V9.75A2.253,2.253,0,0,1,4.75,7.5H8.922v1a4,4,0,0,0,8,0v-1H36.614v1a4,4,0,0,0,8,0v-1h4.172a2.253,2.253,0,0,1,2.25,2.25v8.643ZM48.15,61.5A13.35,13.35,0,1,1,61.5,48.15,13.365,13.365,0,0,1,48.15,61.5Z",
    transform: "translate(0 0)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46719",
    "data-name": "Pfad 46719",
    d: "M309.249,298.4a10.85,10.85,0,1,0,10.85,10.85A10.862,10.862,0,0,0,309.249,298.4Zm0,19.2a8.35,8.35,0,1,1,8.35-8.35A8.359,8.359,0,0,1,309.249,317.6Z",
    transform: "translate(-261.099 -261.099)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46720",
    "data-name": "Pfad 46720",
    d: "M364.212,338.4a1.25,1.25,0,0,0-1.25,1.25v4l-1.277,1.017a1.25,1.25,0,1,0,1.558,1.955l1.748-1.393a1.25,1.25,0,0,0,.471-.978v-4.6A1.25,1.25,0,0,0,364.212,338.4Z",
    transform: "translate(-316.062 -296.099)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46721",
    "data-name": "Pfad 46721",
    d: "M175.393,224.048l-6.71,15.266a1.25,1.25,0,1,0,2.289,1.006l7.481-17.019a1.25,1.25,0,0,0-1.144-1.753l-6.215.307a1.25,1.25,0,0,0,0,2.5Z",
    transform: "matrix(0.914, -0.407, 0.407, 0.914, -225.016, -103.643)",
    fill: "#a5b5af"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_556",
    "data-name": "Ellipse 556",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(15.799 54.75)",
    fill: "#a5b5af"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.c6482bc6ed90600f46d9cba2b6ecd1d9.svg";
export { ForwardRef as ReactComponent };